export const SECTION_BACKGROUNDS = ['default', 'subtle', 'inverse', 'brand'] as const;
export type SectionBackground = (typeof SECTION_BACKGROUNDS)[number];
